import Meta from './meta'

export default Meta
